import { createFileRoute } from '@tanstack/react-router';
import A2UIGalleryPage from '@/a2ui/gallery/A2UIGalleryPage';
import { loadTypedA2UIRouteData } from '@/a2ui/router/loadA2UIRouteDataClient';

export const Route = createFileRoute('/_workbench/a2ui-examples')({
  loader: () => loadTypedA2UIRouteData('/a2ui-examples', 'gallery'),
  component: () => {
    const data = Route.useLoaderData();
    return <A2UIGalleryPage copy={data.copy} examples={data.examples} />;
  },
});
